import { Modal, Button, ModalProps } from "react-bootstrap";
import "./MatterSentModal.css";

const MatterSentModal = (props: ModalProps) => {
  return (
    <Modal {...props} size="lg" centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <h4>Ditt ärende har skickats!</h4>
        <div className="matter-sent-modal-content">
          <p>
            Er fråga kommer nu att skickas till kundtjänst för registrering. När
            det är gjort får ni en bekräftelse via e-post, inklusive ett
            ärendenummer. Därefter hanteras frågan av våra specialister, och ni
            får deras svar genom kundtjänsten. Både er fråga och svaret kan
            komma att användas för att uppdatera vår FAQ, så att framtida kunder
            också kan dra nytta av informationen.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={props.onHide}
          className="btn btn-primary"
          style={{
            backgroundColor: "rgba(0, 61, 76, 1)",
            border: "rgba(0, 61, 76, 1)",
            minWidth: "120px"
          }}
        >
          Stäng
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MatterSentModal;
